import {shallowRef} from 'vue';
import {defineStore} from 'pinia';

export const usePopupsStore = defineStore('popups', () => {
    const isPopupShown = shallowRef(true);

    function setIsPopupShown(payload) {
        isPopupShown.value = payload;
    }

    return {
        isPopupShown,
        setIsPopupShown,
    };
});
